import { config } from './config'
import * as Auth0 from 'auth0-js'
import { enGB } from '../modules/Locales'
import jwt from 'jwt-decode'

class Auth {
  auth0 = new Auth0.WebAuth({
    domain: config.domain,
    clientID: config.clientId,
    redirectUri: config.redirect,
    audience: config.audience,
    responseType: 'id_token token',
    scope: 'openid profile email admin'
  });

  loginCallback = () => {};
  logoutCallback = () => {};
  tokenRenewalTimeout = null;
  userProfile = null;
  userInfoFlag = 'welovesurveys-userInfo'

  localLogin (authResult) {
    authResult.locale = enGB
    const jwtData = jwt(authResult.accessToken)
    authResult.expiresAt = Date.now() + (authResult.expiresIn * 1000)
    authResult.permissions = jwtData.permissions
    localStorage.setItem(this.userInfoFlag, JSON.stringify(authResult))
    this.userProfile = authResult
    this.scheduleRenewal()
    this.loginCallback({ loggedIn: true })
  }

  localLogout () {
    localStorage.removeItem(this.userInfoFlag)
    this.userProfile = null
    this.logoutCallback({ loggedIn: false })
  }

  getAccessToken () {
    return this.userProfile ? this.userProfile.accessToken : null
  }

  renewToken () {
    console.log('renewToken')
    this.auth0.renewAuth({}, (err, authResult) => {
      if (err) {
        console.log(err)
      } else {
        this.localLogin(authResult)
      }
    })
  }

  scheduleRenewal () {
    if (this.userProfile) {
      const delay = this.userProfile.expiresAt - Date.now()
      console.log('scheduleRenewal ', delay)
      if (delay > 0) {
        this.tokenRenewalTimeout = setTimeout(() => {
          this.renewToken()
        }, delay)
      }
    }
  }

  login () {
    this.auth0.popup.authorize({}, (err, authResult) => {
      console.log(err, authResult)
      if (err) this.localLogout()
      else {
        this.localLogin(authResult)
      }
    })
  }

  isAuthenticated () {
    if (!this.userProfile) {
      this.userProfile = this.getUserInfo()
      this.scheduleRenewal()
    }
    return this.userProfile !== null
  }

  getLocale () {
    return this.userProfile ? this.userProfile.locale : enGB
  }

  setLocale (locale) {
    if (!this.userProfile) {
      this.userProfile = this.getUserInfo()
    }
    this.userProfile.locale = locale
    localStorage.setItem(this.userInfoFlag, this.userProfile)
  }

  getUserName () {
    return this.userProfile ? this.userProfile.idTokenPayload.nickname : null
  }

  getAvatar () {
    return this.userProfile ? this.userProfile.idTokenPayload.picture : null
  }

  getRefreshToken () {
    return this.userProfile ? this.userProfile.refreshToken : null
  }

  getScopes () {
    return this.userProfile ? this.userProfile.scope.split(' ') : []
  }

  getPermissions () {
    return this.userProfile ? this.userProfile.permissions : []
  }

  getUserInfo () {
    try {
      const data = localStorage.getItem(this.userInfoFlag)
      if (data) {
        return JSON.parse(data)
      }
      return null
    } catch (err) {
      console.log('Parsing error', err)
      return null
    }
  }

  logout () {
    this.localLogout()
    this.auth0.logout({
      returnTo: config.logoutUrl,
      clientID: config.clientId
    })
  }
}

const auth = new Auth()

export default auth



// WEBPACK FOOTER //
// ./src/auth/service.js